module.exports = __webpack_public_path__ + "img/group.538e7ba6.jpg";